import { createContext, useState, useEffect } from "react";
import { getData } from "./Api";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await getData("/settings");
                if (response.success) {
                    setSettings(response.data);
                }
            } catch (error) {
                console.error("Error loading settings:", error);
            }
        };

        fetchSettings();
    }, []);

    return (
        <SettingsContext.Provider value={{ settings }}>
            {children}
        </SettingsContext.Provider>
    );
};